import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { notifyPromise } from "../../../Utils/Helper";
import { momumpayPayoutSuccess, momumpayPayoutFailure } from "../../Action";
import { MONUMPAY_WITHDRAWAL } from "../../Action/actionTypes";

function* monumpayPayoutRequest(action) {
    try {
        console.log("monumpayPayoutRequest", action);
        
        const { data } = yield notifyPromise(
            API.post("/monumpay-withdrawal", action?.payload)
        );
        if (action?.payload?.callback) {
            yield call(action.payload.callback, data);
        }
        if (data?.meta?.code === 200) {
            yield put(momumpayPayoutSuccess(data?.data));

        } else {
            yield put(momumpayPayoutFailure());
        }
    } catch (error) {
        yield put(momumpayPayoutFailure());
    }
}

export function* watchMonumpayPayoutAPI() {
    yield takeEvery(MONUMPAY_WITHDRAWAL, monumpayPayoutRequest);
}

export default function* rootSaga() {
    yield all([watchMonumpayPayoutAPI()]);
}
